import { useState, useCallback } from 'react';
import imageCompression from 'browser-image-compression';

interface CompressionOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  useWebWorker?: boolean;
}

export const useImageCompression = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const compressImage = useCallback(
    async (file: File, options: CompressionOptions): Promise<File | null> => {
      setIsLoading(true);
      setError(null);
      try {
        const compressedFile = await imageCompression(file, {
          maxSizeMB: 1, // Default max size
          useWebWorker: true,
          ...options, // User-provided options will override defaults
        });
        return compressedFile;
      } catch (e) {
        setError(e as Error);
        console.error('Image compression error:', e);
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { compressImage, isLoading, error };
};
